module.exports = __webpack_public_path__ + "img/tema-2-1.a13be30f.png";